import React from "react";

const NotPopularListItem = ({ category, handleSelectCategory }) => {
  return (
    <li
      onClick={() =>
        handleSelectCategory(
          category.name,
          category.resultType,
          category.restaurantAddressPostalCode,
          category.restaurantAddressSlugAdminWard,
          category.restaurantAddressSlugCityName,
          category.restaurantSlugName,
          true
        )
      }
    >
      <a href="javascript: void(0)">{category.name}</a>
    </li>
  );
};

export default NotPopularListItem;